export const { VITE_API_PATH, VITE_PIWIK_ID, VITE_PIWIK_URL, VITE_SENTRY_DSN, VITE_SENTRY_ENVIRONMENT, VITE_RELEASE } =
  import.meta.env;
